import React from 'react'
import { withRouter } from 'react-router'
import SetTitleInputField from './SetTitleInputField'
import Button from '../uiKit/Button'
import { NavLink } from 'react-router-dom'
import Icon from '../misc/Icons'
import Dropdown from '../uiKit/Dropdown'
import DropdownDivider from '../uiKit/DropdownDivider'
import DropdownItem from '../uiKit/DropdownItem'
import PollsForItemList from '../uiKit/PollsForItemList'
import AddToQueueDropdown from '../uiKit/AddToQueueDropdown'
import CoreHelpDropdownItems from '../CoreHelpDropdownItems'
 
 
class AddToClassDropdownButton extends React.Component{

	render(){
		const {onClickFunction, isOpen}=this.props
		
		return(
			<button className={'btn btn--mid btn--white btn--dropdown addToClassDropdownButton ' + (isOpen ? ' btn--dropdown--open' : '')} onClick={onClickFunction}>
			Add to Queue
			</button>
		)
	}
}
 

class EditorTopBar extends React.Component{

	render(){
		const {isNewQuestion,item,isSet,itemIsLockedByAnotherUser,isPublicConsumer,isPublicAuthor,isViewOnly,parentRepo}=this.props	
		let isCreated=false
		if(item.id){
			isCreated=true
		}
		let inSharedRepo = false
		if(parentRepo && parentRepo.shared){
			inSharedRepo = true
		}
		
		

		
		let newFlag=true
		const localStorageDoNotShowImportQuestionsNewFlag = JSON.parse(localStorage.getItem('doNotShowImportQuestionsNewFlag'))
		if(localStorageDoNotShowImportQuestionsNewFlag){
			newFlag=false
		}




		return(
			<div className={'itemEditor-topBar' + (isSet ? ' is--set' : ' is--question')}>
				<div className='itemEditor-topBar-left'>
					
					<NavLink to={'/library'} >	
   					<Button name='Home' iconName='home' />
					</NavLink>

					{isSet && !isViewOnly &&
						<button 
							className={'btn btn--mid btn--white itemEditor-topBar-newQuestion tooltip tooltip--label' + (this.props.maxNumOfQuestionsReached ? ' itemEditor-topBar-newQuestion--maxLimitReached' :'') + (itemIsLockedByAnotherUser ? ' itemEditor-topBar-newQuestion--isLocked' :'')} 
							data-tooltip={(this.props.maxNumOfQuestionsReached || itemIsLockedByAnotherUser) ? ('') : ('New Question')}
							onClick={()=>{this.props.newQuestionInSet()}}
							id='addQuestionButton'
							tabIndex={0}
							onKeyDown={(e)=>{this.props.handleKeyPressNewQuestionButton(e)}}
							disabled={this.props.maxNumOfQuestionsReached || itemIsLockedByAnotherUser}
						>
							<Icon name='plus' />
						</button>
					}
					
	        {isSet && !isViewOnly &&
						<Button 
							disabled={(this.props.maxNumOfQuestionsReached || itemIsLockedByAnotherUser ||isViewOnly)}
							name='import'
							tooltipLabel='Import Questions'
							tooltipLabelTypeLabel
							iconName="import-questions"
							onClickFunction={this.props.showImportQuestionsModal}
						/>
					}		

					{isSet && newFlag && !isViewOnly &&
						<div className='itemEditor-topBar-left-importQuestionsNewBadge'>
							New
						</div>
					}

					{isSet && isViewOnly &&
						<Button 							
							name='addCopyLibrary'									
							label='Make a Copy and Edit'
							onClickFunction={this.props.showDuplicateAndEditModal}
						/>

					}
					


					{ !isSet && !isNewQuestion &&
						<React.Fragment>
							{!isViewOnly &&
								<Button name='convert' disabled={itemIsLockedByAnotherUser} label='Convert to Set' onClickFunction={this.props.convertToSet} /> 
							}
							<Button name='copy' label='Copy to Clipboard' onClickFunction={this.props.copyQuestion} /> 
							
						</React.Fragment>
					}
					
					
				
				</div>

				<div className='itemEditor-topBar-center'>

					{isSet &&
						<SetTitleInputField 
							title={item.name}
							isViewOnly={isViewOnly}
							lockedByAnotherUser={itemIsLockedByAnotherUser}
							updateSetTitle={this.props.updateSetTitle}
							inSharedRepo={inSharedRepo}
							isPublicConsumer={isPublicConsumer}
							isPublicAuthor={isPublicAuthor}
						/>
					}

					{!isSet &&				
						<div className='itemEditor-topBar-title'>
							{inSharedRepo &&
								<Icon name='shared' />
							}
							{!inSharedRepo && isViewOnly && !isPublicConsumer && 
								<Icon name='lock' />
							}
							{isPublicConsumer &&
								<Icon name='globe-shared' />
							}
							{isPublicAuthor &&
								<Icon name='globe-shared-author' />
							}
							Question Editor							
						</div>
					}


				</div>		 		
				
				<div className='itemEditor-topBar-right'>											
					
					{isCreated ===true &&
						<PollsForItemList item={item}/>
					}					

					{isCreated ===true &&
						<AddToQueueDropdown dropdownButton={<AddToClassDropdownButton />} item={item}/>						
	        }
	      	

	        {!isSet && !isNewQuestion && !isViewOnly &&
	        	<Button name='createnew' label='Create New' onClickFunction={this.props.newQuestionEditorTab} /> 
	        }	         	
		

					{isSet &&
						<Button name='print' tooltipLabel='Print Set Handout' tooltipLabelTypeLabel iconName="print-set-handout" disabled={itemIsLockedByAnotherUser || !isCreated} onClickFunction={this.props.openPrintModal} />
					}




					<Dropdown> 
					 	<DropdownItem label='Set Editor Help' onSelect={()=>{window.open('https://help.plickers.com/hc/en-us/articles/360008948754-Using-Set-Editor-to-Create-Questions','_blank')}} />					 	       		         		

	         		{!isViewOnly &&
        				<DropdownItem disabled={item.id?false:true} label={'Duplicate' + (isSet ? ' Set' : ' Question')} onSelect={this.props.makeACopy}/>
        			}	         		

		         	{isSet && !isViewOnly &&
	         			<DropdownItem label='Rename Set' disabled={itemIsLockedByAnotherUser} onSelect={this.props.focusEditTitle}/>
	         		}

	         		{!isViewOnly &&
		       			<DropdownItem disabled={item.id?itemIsLockedByAnotherUser?true:false:true}  label='Move to Pack...' onSelect={()=>{this.props.showRepoSelectionModal(item)}}/>
		       		}
        	
		        	{!isViewOnly &&
		       			<DropdownItem disabled={item.id?itemIsLockedByAnotherUser?true:false:true} warning label='Send to Trash' onSelect={()=>{this.props.archiveItem()}}/>
		       		}
		       		
       			<DropdownDivider />	 
		         	
        	
	       		<CoreHelpDropdownItems/>

        	</Dropdown>					

				</div>
			</div>
		)
	}
}



export default withRouter(EditorTopBar)

	       		